import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCartArrowDown, faCartPlus } from '@fortawesome/free-solid-svg-icons';
import { ShopModel } from '../shop.model';
import { ShopService } from '../shop.service';
import { AuthUserModel } from 'src/app/auth/auth-user.model';
import { BrandModel } from '../../brands/brand.model';
import { BrandService } from '../../brands/brand.service';

export interface AddOrEditShopDialogData {
  shopModel: ShopModel,
  isNewShop: boolean
}

@Component({
  selector: 'shop-add-or-edit-dialog',
  templateUrl: './shop-add-or-edit.dialog.html',
  styleUrls: ['./shop-add-or-edit.dialog.scss']
})

export class ShopAddOrEditDialog implements OnInit {
  
  faShopAdd = faCartPlus;
  faShopEdit = faCartArrowDown;
  authenticatedUser: AuthUserModel;
  brandFormControl = new FormControl();
  shopNameFormControl = new FormControl('', [Validators.required]);
  shopNumberFormControl = new FormControl('', [Validators.required]);
  streetFormControl = new FormControl('', [Validators.required]);
  postcodeFormControl = new FormControl('', [Validators.required]);
  cityFormControl = new FormControl('', [Validators.required]);
  phoneNumberFormControl = new FormControl();
  emailAddressFormControl = new FormControl(null, [Validators.email]);
  shopFormGroup: FormGroup;
  brands: BrandModel[] = [];

  constructor(
    public shopService: ShopService,
    public brandService: BrandService,
    public dialogRef: MatDialogRef<ShopAddOrEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddOrEditShopDialogData,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.brands = this.brandService.brandList.model;
    
    this.shopFormGroup = this.formBuilder.group({
      brand: this.brandFormControl,
      shopName: this.shopNameFormControl,
      shopNumber: this.shopNumberFormControl,
      street: this.streetFormControl,
      postcode: this.postcodeFormControl,
      city: this.cityFormControl,
      phoneNumber: this.phoneNumberFormControl,
      emailAddress: this.emailAddressFormControl
    });

    if(this.brands.length > 1){
      this.shopFormGroup.get('brand').setValidators(Validators.required);
    }

    if (!this.data.isNewShop) {
      this.brandFormControl.setValue(this.data.shopModel.brandId);
      this.shopNameFormControl.setValue(this.data.shopModel.shopName);
      this.shopNumberFormControl.setValue(this.data.shopModel.shopNumber);
      this.streetFormControl.setValue(this.data.shopModel.street);
      this.postcodeFormControl.setValue(this.data.shopModel.postcode);
      this.cityFormControl.setValue(this.data.shopModel.city);
      this.phoneNumberFormControl.setValue(this.data.shopModel.phoneNumber);
      this.emailAddressFormControl.setValue(this.data.shopModel.emailAddress);
    }
  }

  getBrandName(id: number){
    return this.brands.find(brand => brand.id == id)?.name;
  }

  onOkClick(): void {
    if(this.brands.length == 1){
      this.data.shopModel.brandId = this.brands[0].id;
    } else {
      this.data.shopModel.brandId = this.brandFormControl.value;  
    }
    this.data.shopModel.shopName = this.shopNameFormControl.value;
    this.data.shopModel.shopNumber = this.shopNumberFormControl.value;
    this.data.shopModel.street = this.streetFormControl.value;
    this.data.shopModel.postcode = this.postcodeFormControl.value;
    this.data.shopModel.city = this.cityFormControl.value;
    this.data.shopModel.phoneNumber = this.phoneNumberFormControl.value;
    this.data.shopModel.emailAddress = this.emailAddressFormControl.value;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
